export default __webpack_public_path__ + "static/media/menu.6ef91c4e.svg";